// extracted by mini-css-extract-plugin
module.exports = {"JoinNow":"JoinNow_JoinNow__l0orv"};